import { render, staticRenderFns } from "./ComLeadCard.vue?vue&type=template&id=3d48e47f&"
import script from "./ComLeadCard.vue?vue&type=script&lang=js&"
export * from "./ComLeadCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports